// extracted by mini-css-extract-plugin
module.exports = {"container":"_3wYFcXO1itF1SFRodbgWJs","heading-container":"_3J2X4jSXzOjMbG4fbJgTaM","header":"_26ekcAlhCmjadW7ShhS7aj","on-off-btn":"_3t9wqiT3dGuO4aQrXOvdo5"};